import { render } from "./follow-button.vue?vue&type=template&id=f0ad1ef8&ts=true"
import script from "./follow-button.vue?vue&type=script&lang=ts"
export * from "./follow-button.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__